import { createSlice } from '@reduxjs/toolkit';
import { GetBlogger, GetSingleBlogger, PostComment } from './blogServicesSync';

const initialState = {
  articleDetails: [],
  storiesPageLoad: false,
  singleStoryPageLoader: false,
  singleStoryPageDetails: {},
  allBlogComment: {},
  commentLoader: false,
  commentMessage: '',
  message: ''
};

export const userBloggerSlice = createSlice({
  name: 'user_blog',
  initialState,
  reducers: {
    reset: (state) => {
      state.storiesPageLoad = false;
      state.articleDetails = [];
      state.singleStoryPageLoader = false;
      state.singleStoryPageDetails = {};
      state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetBlogger.pending, (state) => {
        state.storiesPageLoad = true;
      })
      .addCase(GetBlogger.fulfilled, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
        state.articleDetails = action?.payload?.data;
      })
      .addCase(GetBlogger.rejected, (state, action) => {
        state.storiesPageLoad = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(GetSingleBlogger.pending, (state) => {
        state.singleStoryPageLoader = true;
      })
      .addCase(GetSingleBlogger.fulfilled, (state, action) => {
        state.singleStoryPageLoader = false;
        state.message = action.payload.message;
        state.singleStoryPageDetails = action.payload?.data;
      })
      .addCase(GetSingleBlogger.rejected, (state, action) => {
        state.singleStoryPageLoader = false;
        state.message = action.payload?.message;
      });

    builder
      .addCase(PostComment.pending, (state) => {
        state.commentLoader = true;
      })
      .addCase(PostComment.fulfilled, (state, action) => {
        state.commentLoader = false;
        state.commentMessage = action.payload?.message;
        state.allBlogComment = {
          ...state.allBlogComment,
          data: [...state.allBlogComment?.data, action.payload?.data],
          count: state.allBlogComment?.count + 1
        };
      })
      .addCase(PostComment.rejected, (state, action) => {
        state.commentLoader = false;
        state.commentMessage = action.payload?.message;
      });
  }
});

export const { reset } = userBloggerSlice.actions;
export default userBloggerSlice.reducer;
